import React, { useMemo } from 'react'
import { Pie } from 'react-chartjs-2';

const AlertByStatusPiechart = ({ handleModalShow, siteId, getcsvFileName, alertsData }) => {
  // Flatten alertsData if it's an object with keys (as in your API response)
  const flatAlertsData = Array.isArray(alertsData)
    ? alertsData
    : alertsData && typeof alertsData === 'object'
      ? Object.values(alertsData).flat()
      : [];

  // Memoize statusLabel and statusValue so they update when alertsData changes
  const { statusLabel, statusValue } = useMemo(() => {
    let statusLabel = [];
    let statusValue = [];
    // Use WidgetID === 16
    const widget16 = flatAlertsData.find(item => item.WidgetID === 16 && item.WidgetData);
    if (widget16 && widget16.WidgetData.InterfacetypeName && widget16.WidgetData.AlertCount) {
      statusLabel = widget16.WidgetData.InterfacetypeName;
      statusValue = widget16.WidgetData.AlertCount;
    }
    return { statusLabel, statusValue };
  }, [flatAlertsData]);


  const colorMap = {
    Open: 'rgb(224, 97, 110)',
    Acknowledged: 'rgb(98, 126, 227)',
    Closed: 'rgb(107, 225, 134)'
  };
  //const backgroundColors = statusLabel.map(label => colorMap[label] || 'gray');

  const data = {
    labels: statusLabel,
    datasets: [{
      data: statusValue,
      backgroundColor: [
            'rgb(173, 111, 224)', 
            'rgb(224, 111, 224)', 
            'rgb(194, 86, 186)', 
            'rgb(195, 84, 156)', 
            'rgb(137, 113, 234)', 
            'rgb(111, 196, 224)', 
            'rgb(111, 224, 205)', 
            'rgb(111, 224, 137)', 
            'rgb(151, 224, 111)', 
            'rgb(224, 222, 111)', 
            'rgb(224, 137, 111)', 
            'rgb(218, 96, 96)', 
          ],
      hoverOffset: 4
    }]
  };

  const option = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            let dataset = tooltipItem.dataset;
            let value = dataset.data[tooltipItem.dataIndex];
            let label = dataset.labels ? dataset.labels[tooltipItem.dataIndex] : "";
            return `${label}: ${value}`;
          },
        },
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 14,
          fontColor: '#474747',
          fontFamily: '7px Montserrat',
        },
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          size: 14,
        },
        align: "top",
        formatter: (value) => value,
      },
    },
    onClick: (event, elements, chart) => {
      if (elements && elements.length > 0) {
        const element = elements[0];
        const index = element.index;
        const label = chart.data.labels[index];
        if (typeof handleModalShow === "function") {
          handleModalShow({ InterfacetypeName: label }, "Alert", 30, { SiteID: [siteId] }, getcsvFileName('Alert', label), "Alert Counts By Status");
        }
      }
    }
  };

  return (
    <div style={{ padding: "10px", height: "90%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {statusLabel.length > 0 ? (
        <Pie data={data} options={option} />
      ) : (
        <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "gray" }}>
          No alerts found
        </div>
      )}
    </div>
  );
}

export default AlertByStatusPiechart